import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, InteractionStatus } from '@azure/msal-browser';
import { isUndefinedOrNull } from '@psnb/services';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'psnb-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy, OnInit {
  private readonly destroying$: Subject<void>;

  public constructor(
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    this.destroying$ = new Subject<void>();
  }

  public ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus): boolean => status === InteractionStatus.None
        ),
        takeUntil(this.destroying$)
      )
      .subscribe((): void => {
        this.checkAndSetActiveAccount();
      });
  }

  public ngOnDestroy(): void {
    this.destroying$.next();
    this.destroying$.complete();
  }

  private checkAndSetActiveAccount(): void {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    const activeAccount: AccountInfo = this.msalService.instance.getActiveAccount();

    if (isUndefinedOrNull(activeAccount) && this.msalService.instance.getAllAccounts().length > 0) {
      const accounts: AccountInfo[] = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }
}
